import { useId } from "react";

const DpmIcon = ({ width = 84, height = 81, ...props }) => {
  const uid = useId().replace(/:/g, "");
  const clipId = `dpm-icon-clip-${uid}`;

  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 84 81'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d='M20 1L46.5811 1L71 25.7236V73C71 76.866 67.866 80 64 80L20 80C16.134 80 13 76.866 13 73V8C13 4.13401 16.134 1 20 1Z'
          fill='#F3F6FA'
          stroke='#D5D9DF'
          strokeWidth='2'
        />
        <path
          d='M46 2.02502V20.325C46 23.6387 48.6863 26.325 52 26.325L70 26.325'
          stroke='#D5D9DF'
          strokeWidth='2'
          strokeLinecap='round'
        />
      </g>
      <rect y='39' width='54' height='32' rx='4' fill='#146E37' />
      <path
        d='M12.1411 62L7.50043 62V48.9091L12.1794 48.9091C13.4962 48.9091 14.6297 49.1712 15.58 49.6953C16.5303 50.2152 17.2611 50.9631 17.7724 51.9389C18.2881 52.9148 18.5459 54.0824 18.5459 55.4418C18.5459 56.8054 18.2881 57.9773 17.7724 58.9574C17.2611 59.9375 16.526 60.6896 15.5672 61.2138C14.6126 61.7379 13.4706 62 12.1411 62ZM10.2682 59.6286L12.026 59.6286C12.8442 59.6286 13.5324 59.4837 14.0906 59.1939C14.6531 58.8999 15.075 58.446 15.3563 57.8324C15.6418 57.2145 15.7845 56.4176 15.7845 55.4418C15.7845 54.4744 15.6418 53.6839 15.3563 53.0703C15.075 52.4567 14.6553 52.005 14.097 51.7152C13.5388 51.4254 12.8506 51.2805 12.0324 51.2805L10.2682 51.2805V59.6286ZM20.6231 62V48.9091L25.7879 48.9091C26.7808 48.9091 27.6267 49.0987 28.3256 49.478C29.0244 49.853 29.5571 50.375 29.9236 51.044C30.2943 51.7088 30.4797 52.4759 30.4797 53.3452C30.4797 54.2145 30.2922 54.9815 29.9172 55.6463C29.5422 56.3111 28.9988 56.8288 28.2872 57.1996C27.5798 57.5703 26.7233 57.7557 25.7176 57.7557L22.4257 57.7557V55.5376L25.2702 55.5376C25.8028 55.5376 26.2417 55.446 26.5869 55.2628C26.9363 55.0753 27.1963 54.8175 27.3667 54.4893C27.5415 54.157 27.6288 53.7756 27.6288 53.3452C27.6288 52.9105 27.5415 52.5312 27.3667 52.2074C27.1963 51.8793 26.9363 51.6257 26.5869 51.4467C26.2375 51.2635 25.7943 51.1719 25.2574 51.1719L23.3909 51.1719V62L20.6231 62ZM32.3044 48.9091L35.7178 48.9091L39.3229 57.7045L39.4763 57.7045L43.0814 48.9091L46.4948 48.9091V62L43.8101 62V53.4794L43.7015 53.4794L40.3137 61.9361L38.4855 61.9361L35.0978 53.4474L34.9891 53.4474V62L32.3044 62V48.9091Z'
        fill='white'
      />
      <defs>
        <clipPath id={clipId}>
          <rect width='60' height='81' fill='white' transform='translate(12)' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DpmIcon;
